export default __webpack_public_path__ + "static/media/title.51e6b58b.svg";